"use client";

import { useTranslations } from 'next-intl';
import Accordion from '../Accordeon/Accordeon';

function FAQ() {
  const t = useTranslations('home.faq');

  // Get the raw items object from translations and convert to array
  const itemsObj = t.raw('items');
  const items = itemsObj ? Object.values(itemsObj) : [];

  return (
    <div className="section-py px-4" id='faq'>
      <h2 className="text-title text-center">{t('title')}</h2>
      <div className=''>
        <Accordion data={items}/>
      </div>
    </div>
  );
}

export default FAQ
